module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5EqVu"))).then(() => parcelRequire('hEqeo'));